import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const tenantTermsRoutes = [
  {
    path: 'terms',
    component: () => import('@/features/superAdmin/tenantTerms/TenantTerms.vue'),
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.TermsView,
    },
  },
  {
    path: 'terms/:id',
    component: () => import('@/features/superAdmin/tenantTerms/TenantTermDetail.vue'),
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.TermsView,
    },
  },
]
